import './user-pages.sass';
import axios from 'axios';
import { useEffect, useState, useMemo } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { sortBy, chunk, uniq, filter } from 'underscore';
import { useWindowSize } from 'react-use';
import useAlert from '../hooks/useAlert';
import Pagination from '../components/Pagination';
import selectArrow from '../assets/select-arrow.svg';
import { useTranslation } from 'react-i18next';

const Transactions = () => {
	const { t, i18n } = useTranslation();
	const { sendAlert } = useAlert();
	const token = localStorage.getItem('token');
	const walletAddress = localStorage.getItem('walletAddress');
	const [transactions, setTransactions] = useState([]);

	useEffect(() => {
		axios.get(`/token/getTransactions/${walletAddress}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			}
		}).then((response) => {
			const message = response.data.message;
			const data = response.data.data;

			if (message === 'success') {
				setTransactions(sortBy(data, 'createdAt').reverse());
			}
		}).catch((error) => {
			const message = error.response.data.message;

			switch (message) {
				case 'No token is provided':
					sendAlert(message, t('activity.msg_no_auth'));
					break;

				default:
					sendAlert('Oops! an unexpected error occurred', message);
					break;
			}
		});
	}, [token, walletAddress, sendAlert]);

	const alteredTransactions = useMemo(() => {
		return transactions.map((transaction) => {
			switch (transaction.transactionDetail) {

				case 'Mint':
					transaction.transactionDetail = t('activity.category.mint');
					break;

				case 'Payment':
					transaction.transactionDetail = t('activity.category.payment');
					break;

				case 'Delivery':
					transaction.transactionDetail = t('activity.category.delivery');
					break;

				case 'Relist':
					transaction.transactionDetail = t('activity.category.relist');
					break;

				case 'Exchange':
					transaction.transactionDetail = t('activity.category.redeem');
					break;

				case 'Transfer':
					if (transaction.senderAddress === walletAddress) {
						transaction.transactionDetail = t('activity.category.transfer_out');
					}

					if (transaction.receiverAddress === walletAddress) {
						transaction.transactionDetail = t('activity.category.transfer_in');
					}
					break;
			}

			return transaction;
		});
	}, [transactions, walletAddress]);

	const [filterSelect, setFilter] = useState('all');

	const options = useMemo(() => {
		const unique = uniq(alteredTransactions, 'transactionDetail');

		return unique.map((item) => {
			return item.transactionDetail;
		});
	}, [alteredTransactions]);

	const filteredTransactions = useMemo(() => {
		if (filterSelect === 'all') return alteredTransactions;
		return filter(alteredTransactions, (transaction) => {
			return transaction.transactionDetail === filterSelect;
		})
	}, [filterSelect, alteredTransactions]);

	const [currentPage, setCurrentPage] = useState(1);

	const { width } = useWindowSize();

	const itemsPerPage = useMemo(() => {
		if (width >= 768) return 12;
		return 6;
	}, [width]);

	const pages = useMemo(() => {
		return chunk(filteredTransactions, itemsPerPage);
	}, [itemsPerPage, filteredTransactions]);

	const currentPageList = useMemo(() => {
		if (pages.length) return pages[currentPage - 1];
		return [];
	}, [currentPage, pages]);

	return (
		<div id='Transactions' className='user-pages'>
			<div className='page-title'>{t('navbar.menu_tx_record')}</div>

			<select className='filter' defaultValue={filterSelect} style={{ backgroundImage: `url(${selectArrow})` }} onChange={(e) => { setFilter(e.target.value) }}>
				<option value='all'>{t('activity.category.all')}</option>

				{options.map((option) => {
					return (
						<option value={option} key={option}>{option}</option>
					)
				})}
			</select>

			<div className='page-content'>
				{currentPageList.length ? (
					<div className='table-wrap'>
						<table>
							<thead>
								<tr>
									<th>{t('activity.table.header.time')}</th>
									<th>{t('activity.table.header.from')}</th>
									<th>{t('activity.table.header.to')}</th>
									<th>{t('activity.table.header.action')}</th>
									<th>{t('activity.table.header.amount')}</th>
									<th>{t('activity.table.header.type')}</th>
									<th>{t('activity.table.header.detail')}</th>
								</tr>
							</thead>

							<tbody>
								{currentPageList.map((transaction, index) => {
									const { transactionHash, senderAddress, receiverAddress, createdAt, transactionAmount, transactionType, transactionDetail, transactionRemark } = transaction;
									
									const date = new Date(createdAt).toLocaleString();

									let transactionTypeCHT = '', 
										transactionItem = '';

									switch (transactionType) {
										case 'nft':
											transactionTypeCHT = t('activity.table.item_type.nft');
											if (transactionRemark) {
												transactionItem = transactionRemark.split('/').slice(-1)[0]
											}
											break;
										case 'point':
											transactionTypeCHT = t('activity.table.item_type.point');
											break;
										case 'currency':
											transactionTypeCHT = t('activity.table.item_type.currency');
											break;
									}

									return (
										<tr key={transactionHash + index}>
											<td>{date}</td>
											<td className={ `ellipsis ${senderAddress == walletAddress ? 'blue' : ''}`}>{senderAddress.slice(2, 8).toLocaleUpperCase()}</td>
											<td className={ `ellipsis ${receiverAddress == walletAddress ? 'blue' : ''}`}>{receiverAddress.slice(2, 8).toLocaleUpperCase()}</td>
											<td>{transactionDetail}</td>
											<td>{transactionAmount}</td>
											<td>{transactionTypeCHT}</td>
											<td className="ellipsis"><Link to={ `/collection/${transactionRemark}` }>{transactionItem.slice(0, 8).toLocaleUpperCase()}</Link></td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				) : (
					<div className='no-transactions'>{t('activity.table.no_data')}</div>
				)}

				<Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pages.length} top={0} />
			</div>

			<div className='monetization-block'>Google ad</div>
		</div >
	)
}

export default Transactions;